import OverlayTips from "../OverlayTips";

function SettingsPageOverlayTipsManager()
{
    PageOverlayTipsManager.call(this);
}

SettingsPageOverlayTipsManager.prototype = _.create(PageOverlayTipsManager.prototype, {

    addBaseTips: function()
    {
        PageOverlayTipsManager.prototype.addBaseTips.apply(this);

        this.add($(".collapsibleGroupHeader").eqOrLast(1), {
            messageKey: "tips.expand_section",
            direction: OverlayTips.DIRECTION_TOP_RIGHT,
            offsetX: 0,
            offsetY: -10
        });

        this.add($(".productsIntegrated .sharedImage").eq(1), {
            messageKey: "tips.shared_settings",
            direction: OverlayTips.DIRECTION_TOP_RIGHT,
            offsetX: 0,
            offsetY: 0
        });

        this.add($("#userGroupsSettingsBlockButton").parent(), {
            messageKey: "general_settings.tips.user_groups",
            direction: OverlayTips.DIRECTION_TOP_LEFT,
            offsetX: 10,
            offsetY: -20,
            outside: {
                direction: OverlayTips.DIRECTION_TOP_RIGHT,
                anchor: OverlayTips.DIRECTION_TOP_LEFT,
                offsetX: 120,
                offsetY: 10
            }
        });

        this.add($("#dateTimeSettingsBlockButton").parent(), {
            messageKey: "general_settings.tips.time_zone_and_calendar",
            direction: OverlayTips.DIRECTION_TOP_LEFT,
            offsetX: 10,
            offsetY: -20,
            outside: {
                direction: OverlayTips.DIRECTION_TOP_RIGHT,
                anchor: OverlayTips.DIRECTION_TOP_LEFT,
                offsetX: 40,
                offsetY: -12
            }
        });

        this.add($("#ptoAndSickBlockSectionButton").parent(), {
            messageKey: "general_settings.tips.balances",
            direction: OverlayTips.DIRECTION_TOP_LEFT,
            offsetX: 10,
            offsetY: -20,
            outside: {
                direction: OverlayTips.DIRECTION_TOP_RIGHT,
                anchor: OverlayTips.DIRECTION_TOP_LEFT,
                offsetX: 210,
                offsetY: -5
            }
        });

        this.add($("#scheduleBlockButton").parent(), {
            messageKey: "general_settings.tips.work_schedule",
            direction: OverlayTips.DIRECTION_TOP_LEFT,
            offsetX: 10,
            offsetY: -20,
            outside: {
                direction: OverlayTips.DIRECTION_TOP_RIGHT,
                anchor: OverlayTips.DIRECTION_TOP_LEFT,
                offsetX: 200,
                offsetY: -5
            }
        });

        this.add($("#personalSchedulesVisibilityBlockButton").parent(), {
            messageKey: "general_settings.tips.access_schedule",
            direction: OverlayTips.DIRECTION_TOP_LEFT,
            offsetX: 10,
            offsetY: -20,
            outside: {
                direction: OverlayTips.DIRECTION_TOP_RIGHT,
                anchor: OverlayTips.DIRECTION_TOP_LEFT,
                offsetX: 220,
                offsetY: 0
            }
        });

        this.add($("#ltmAccessBlockButton").parent(), {
            messageKey: "general_settings.tips.access_ltm",
            direction: OverlayTips.DIRECTION_TOP_LEFT,
            offsetX: 10,
            offsetY: -20,
            outside: {
                direction: OverlayTips.DIRECTION_TOP_RIGHT,
                anchor: OverlayTips.DIRECTION_TOP_LEFT,
                offsetX: 290,
                offsetY: -20
            }
        });

        // TODO: add after making "Automatic leave request processing" section
        // this.add($("#...").parent(), {
        //     messageKey: "general_settings.tips.auto_processing",
        //     direction: OverlayTips.DIRECTION_TOP_LEFT,
        //     offsetX: 10,
        //     offsetY: -20,
        //     outside: {
        //         direction: OverlayTips.DIRECTION_TOP_RIGHT,
        //         anchor: OverlayTips.DIRECTION_TOP_LEFT,
        //         offsetX: 230,
        //         offsetY: -5
        //     }
        // });

        this.add($("#formatsSettingsBlockButton").parent(), {
            messageKey: "general_settings.tips.number_format",
            direction: OverlayTips.DIRECTION_TOP_LEFT,
            offsetX: 10,
            offsetY: -20,
            outside: {
                direction: OverlayTips.DIRECTION_TOP_RIGHT,
                anchor: OverlayTips.DIRECTION_TOP_LEFT,
                offsetX: 150,
                offsetY: -25
            }
        });
    }
});

export default SettingsPageOverlayTipsManager;


// WEBPACK FOOTER //
// ./web/actiplans/js/tips/managers/SettingsPageOverlayTipsManager.js